import { colors } from '@/shahrzad-assets/shared-constants/colors'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { fontSize } from '@/shahrzad-assets/shared-constants/fonts'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { icons } from '../shared-asstes/icons'
import { navigateToHome } from '../shared-utils/navigateToHome'
import { Breakpoint } from 'react-socks'

interface IProps {
  title: string
  back: boolean
  setOpenModal: (key: boolean) => void
  children: any
  goBack?: () => void
  home: boolean
}

const PageTitle = ({
  title,
  back = true,
  children,
  goBack,
  home = true,
}: Partial<IProps>) => {
  const navigate = useNavigate()
  const location = useLocation()

  const backHandler = () => {
    if (location.key !== '1') {
      goBack ? goBack() : navigate(-1)
    } else {
      // Use window.history.back() as a fallback
      window.history.back()
    }
  }

  return (
    <Breakpoint medium down>
      <TitleContainer className='fit-width'>
        <Right>
          {back ? (
            <img src={icons.BACK} className='backIcon' onClick={backHandler} />
          ) : (
            <img src={icons.MENU} alt='menu-icon' />
          )}
          <h2>{title}</h2>
        </Right>
        <Left>
          {home ? (
            <img
              src={icons.HOME_BLACK}
              className='homeIcon'
              onClick={navigateToHome}
            />
          ) : (
            children
          )}
        </Left>
      </TitleContainer>
    </Breakpoint>
  )
}

export default PageTitle

const TitleContainer = styled.header`
  position: fixed;
  z-index: 100;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: ${colors.bg3};
  padding: ${dimens.SPACING_M};
  border-radius: 0 0 ${dimens.BORDER_RADIUS_8} ${dimens.BORDER_RADIUS_8};
  height: ${dimens.PAGE_TITLE_HEIGHT};
`

const Right = styled.div`
  display: flex;
  align-items: center;
  h2 {
    font-size: ${fontSize.MEDIUM};
    margin-right: ${dimens.SPACING_S};
  }
  .backIcon {
    cursor: pointer;
  }
`

const Left = styled.div`
  /* display: flex;
  align-items: center;
  font-size: ${fontSize.NORMAL};
  color: ${colors.RED};
  cursor: pointer;
  img {
    margin-left: ${dimens.SPACING_S};
  } */
  .homeIcon {
    margin: 0;
  }
`
